import { useState, useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { NavLink, useNavigate } from 'react-router-dom';
import { datosFormEmail, datosFormLogin } from 'utils/formData';
import Formulario from '../Formulario/Formulario';
import { IFormulario, LoginRequest } from 'utils/models/interfaces';
import { useError } from 'services/ErrorContext';
import { loginService } from 'services/auth/ServicioAuth';
import { useDispatch } from 'react-redux';
import { loginSuccess } from 'utils/redux/features/authSlice';
import { HowToReg } from '@mui/icons-material';
import { Usuario } from 'utils/models/types';
import Countdown from '../Countdown/Countdown';
import { anchoMaxForms } from 'utils/constants';

const FormLogin = ({ variante }: { variante: 'claro' | 'oscuro' }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario: Usuario = usuarioJSON && JSON.parse(usuarioJSON);
  const { error, setError, loading, setLoading } = useError();
  const [mensajeExito, setMensajeExito] = useState('');
  const mensajeLogin = `¡Bienvenido/a ${usuario?.Nombre}!`;
  const redirectPath = localStorage.getItem('redirectPath');

  const handleSubmit = async (data: IFormulario) => {
    const { email, password } = data;
    const loginRequest: LoginRequest = { Email: email, Password: password };

    try {
      const result = await loginService(loginRequest, setError, setLoading);
      if (result?.usuario) {
        dispatch(loginSuccess(result.usuario));
        setMensajeExito('¡Login realizado con éxito!');
      }
    } catch (error: unknown) {
      setError(error instanceof Error ? error.message : String(error));
    }
  };

  const handleVolver = () => {
    setMensajeExito('');
    redirectPath && navigate(redirectPath);
  };

  const expiracionJSON = localStorage.getItem('expiracionCompra');
  const expiracion = expiracionJSON && JSON.parse(expiracionJSON);

  useEffect(() => {
    if (mensajeExito) {
      const timer = setTimeout(() => {
        // Si hay un redirectPath, navegar a él (ej: cuando viene de una compra)
        if (redirectPath) {
          navigate(redirectPath);
        } else {
          // Si no hay redirectPath, ir al perfil del usuario
          navigate('/usuario');
        }
      }, 2000); // Esperar 2 segundos para que el usuario vea el mensaje de éxito
      return () => clearTimeout(timer);
    }
  }, [mensajeExito, redirectPath, navigate]);

  return (
    <Box mt={4} width={anchoMaxForms}>
      {redirectPath && expiracion && (
        <Countdown
          tiempoExpiracion={expiracion}
          mensaje="Los datos de tu entrada se mantendrán guardados por 5 minutos antes de realizar el pago"
          titulo="¡No te preocupes!"
        />
      )}
      <Formulario
        campos={[...datosFormEmail, ...datosFormLogin]}
        titulo="Iniciar sesión"
        onSubmit={handleSubmit}
        onVolver={handleVolver}
        mensajeExito={mensajeExito}
        mensajeError={error}
        loading={loading}
        tituloMensajeResp={mensajeLogin}
        mensajeAlerta={'Ya podés regresar a la página anterior o acceder a tu cuenta.'}
        textoBoton="Ingresar"
        variante={variante}
        iconoBoton={HowToReg}
      />
      {!usuario && (
        <Box maxWidth={250} mx="auto" display="flex" flexDirection="column" alignItems="center" pb={2}>
          <Button onClick={() => navigate('/restablecer')}>Olvidé mi contraseña</Button>
          <Typography color={variante === 'claro' ? 'black' : 'white'} py={2}>
            Si aún no tenés cuenta
          </Typography>
          <NavLink to={'/registro'} style={{ width: '100%' }}>
            <Button startIcon={<HowToReg />} variant="contained">
              Registrate
            </Button>
          </NavLink>
        </Box>
      )}
    </Box>
  );
};

export default FormLogin;
